import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Accordion, AccordionTab } from "primereact/accordion";
import "./INTERIOR_DESIGN_TEMPLATE.css";
import { Api } from "../../../services/api";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";

import { InteriorDesignTemplate } from "../../../services/Template/interior-design-template";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { useParams } from 'react-router-dom';
import { FaCopy, FaPlus, FaTrash } from 'react-icons/fa';
import { useScreenshot } from 'use-react-screenshot'
import html2canvas from 'html2canvas';
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";

const EDIT_INTERIOR_DESIGN_TEMPLATE = ({ pmId }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isCopyBtnLoading , setIsCopyBtnLoading] = useState(false);


  const ref = useRef(null)
  const ref2 = useRef(null)

  const [projectData, setProjectData] = useState([]);
  const navigate = useNavigate();
  const { editId } = useParams();
  const toast = useRef(null);

  const formik = useFormik({
    initialValues: InteriorDesignTemplate.getFormName(),
    validate: (data) => {

    },

    // onSubmit: (data) => {
    //   if (data.interior_id == undefined) {
    //     return;
    //   }
    //   console.log("data");
    //   console.log(data);


    //   data.user_id = localStorage.getItem('user_id');
    //   data.role_id = localStorage.getItem('role_id');
    //   var url = Api.API_BASE_URL + 'interior-template/update/' + data.interior_id;
    //   if (data.interior_id == 0) {
    //     url = Api.API_BASE_URL + 'interior-template/create';
    //   }


    //   // var url = Api.API_BASE_URL + 'interior-template/update/' + editId;


    //   fetch(url, {
    //     method: "POST",
    //     headers: {

    //     },
    //     body: JSON.stringify(data),
    //   })
    //     .then((response) => response.json())
    //     .then((Josn) => {
    //       setExistPageWithoutSave(false);
    //       if (Josn.error != '') {
    //         toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

    //       } else {
    //         toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });

    //         // navigate('/interior-design-dashboard')
    //         // getUser();
    //       }

    //     })
    //     .catch((error) => {
    //       console.error("Error:", error);
    //     });



    // }
  });

  const [existPageWithoutSave, setExistPageWithoutSave] = useState(false);

  useEffect(() => {
    getProjectDetails();
    getDetailsInterioDesign(pmId);

    return () => {
      // Cleanup tasks before the component is unmounted
      // if (existPageWithoutSave) {
      // if (window.confirm('Do you want to save changes you made to this document?')) {
      // formik.handleSubmit();
      // }
      // }
    };
  }, [pmId,]);

  const [preConstructionShedule, setPreConstructionShedule] = useState([1]);
  const handleAddInputForPreConstructionShedule = () => {
    setPreConstructionShedule([...preConstructionShedule, 1]);
    var t = {
      genrealProjectCheckListTitle: "",
      misc1: "",
      miscReason: '',
    };
    formik.values.section_10.push(t);

  };

  const handleDeleteInputForreConstructionShedule = (index) => {
    setPreConstructionShedule([...preConstructionShedule, 2]);
    var newArray = [...preConstructionShedule];
    newArray.splice(index, 1);
    formik.values.section_10.splice(index, 1);
    setPreConstructionShedule(newArray);
  };

  const getDetailsInterioDesign = (id) => {
    // interior-template/get-interior/{editId}
    var _body = {
      userId: 1,
    }
    fetch(Api.API_BASE_URL + 'interior-template/get-interior/' + id, {
      method: "POST",

      body: JSON.stringify(_body),
    })
      .then((response) => response.json())
      .then((response) => {
        // setIsLoading(false);

        if (response.error != '') {
          formik.setFieldValue('project_id', response.project_id);
          formik.setFieldValue('interior_id', 0);
        } else {
          formik.setFieldValue('project_id', response.project_id);
          formik.setFieldValue('interior_id', response.interior_id);
          InteriorDesignTemplate.section_1_List().forEach(element => {
            formik.setFieldValue(element, response.sec_1[element]);
          });

          InteriorDesignTemplate.section_2_List().forEach(element => {
            formik.setFieldValue(element, response.sec_2[element]);
          }); InteriorDesignTemplate.section_3_List().forEach(element => {
            formik.setFieldValue(element, response.sec_3[element]);
          });



          if (response.sec_4.length != 0) {
            const templateSec4 = InteriorDesignTemplate.getFormName().section_4;
            const savedMap4 = {};
            response.sec_4.forEach(item => { if (item && item.selection) savedMap4[item.selection] = item; });
            const mergedSec4 = templateSec4.map(tmpl => savedMap4[tmpl.selection] !== undefined ? savedMap4[tmpl.selection] : tmpl);
            formik.setFieldValue(`section_4`, mergedSec4);
          }
          if (response.sec_5.length != 0) {
            const templateSec5 = InteriorDesignTemplate.getFormName().section_5;
            const savedMap5 = {};
            response.sec_5.forEach(item => { if (item && item.selection) savedMap5[item.selection] = item; });
            const mergedSec5 = templateSec5.map(tmpl => savedMap5[tmpl.selection] !== undefined ? savedMap5[tmpl.selection] : tmpl);
            formik.setFieldValue(`section_5`, mergedSec5);
          }
          if (response.sec_6.length != 0) {
            formik.setFieldValue(`section_6`, response.sec_6);
          }
          if (response.sec_7.length != 0) {
            formik.setFieldValue(`section_7`, response.sec_7);
          }
          if (response.sec_8.length != 0) {
            formik.setFieldValue(`section_8`, response.sec_8);
          }



          if (response.sec_9.length != 0) {
            formik.setFieldValue(`section_9`, response.sec_9);
          }
          if (response.sec_10.length != 0) {
            formik.setFieldValue(`section_10`, response.sec_10);
            var t = [];
            response.sec_10.forEach(element => {
              t.push(0)
            });
            setPreConstructionShedule(t);
          }





          formik.setFieldValue('project_id', response.project_id);
          formik.setFieldValue('interior_id', response.interior_id);

        }




        setIsLoading(false);

      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  }

  const goBack = () => {
    // navigate('/interior-design-dashboard')
  }



  const getProjectDetails = () => {
    // fetch.
    var user_id = localStorage.getItem('user_id');
    var role_id = localStorage.getItem('role_id');
    var _body = {
      userId: user_id,
      role_id: role_id,
    }
    fetch(Api.API_BASE_URL + 'template/get-project-for-template', {
      method: "POST",

      body: JSON.stringify(_body),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response.result);
        // setIsLoading(false);
        setProjectData(response.result);

        //* -------------------------------------------------------
        InteriorDesignTemplate.section_1_List().forEach(element => {
          formik.setFieldValue(element, response.pm_section_1[element]);
        });

        //* -------------------------------------------------------
        setIsLoading(false);


      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  }


  const ProjectOnChange = (selectId) => {

    formik.setFieldValue('project_id', selectId)

  }

  //? ________________________________

  const headerStyle = {
    background: "#FEC025",
    border: "1px solid #E9ECEF",
    textAlign: "center",
    fontSize: "18px",
  };

  const cellStyle = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    // textAlign: 'center',
  };

  const cellStyleW = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",
    backgroundColor: 'white',
    paddingTop: '5px'
  };

  const yesCellStyle = {
    ...cellStyleW,
    // background: "#FEC025",
  };



  const firstColumnWidth = {
    width: "80px", // Adjust the width as needed
  };

  const dropdownCellStyle = {
    ...yesCellStyle,
    padding: "0",
    // Remove padding to fit the dropdown
  };

  //? --------------------------------------

  //! ________________________________
  const renderTextArea = (fieldName, placeholder, formdata = '', maxLine = 2) => (
    <textarea
      placeholder={placeholder}
      name={fieldName}
      id={fieldName}
      rows={maxLine}
      value={formdata !== '' ? formdata : formik.values[fieldName]}
      onChange={(e) => {
        setExistPageWithoutSave(true);
        console.log(e.target.value)
        formik.setFieldValue(fieldName, e.target.value)
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', fontSize: '16px', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
    ></textarea>
  );

  const renderTextAreaFull = (fieldName, placeholder, formData = '', maxLine = 2,) => (
    <InputTextarea
      placeholder={placeholder}
      name={fieldName}
      autoResize
      id={fieldName}
      rows={maxLine}
      value={formData !== '' ? formData : formik.values[fieldName]}
      onChange={(e) => {
        console.log(e.target.value)
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', fontSize: '16px', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', }}
    ></InputTextarea>
  );

  const renderInputArea = (fieldName, placeholder, type = 'text', formdata = '') => (
    <input
      type={type}
      placeholder={placeholder}
      name={fieldName}
      id={fieldName}
      value={formdata !== '' ? formdata : formik.values[fieldName]}
      // onChange={(e) => { formik.setFieldValue(fieldName, e.target.value) }}
      onChange={(e) => {
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.target.value)
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{
        width: '100%',
        height: '40px',
        boxSizing: 'border-box',
        border: 'none',
        fontSize: '16px',
        textAlign: 'center',
        marginTop: '0px',
      }}
    />
  );

  const renderInputAreaForAmount = (fieldName, formData = '') => (
    <InputNumber
      inputId="currency-us"
      value={formData != '' ? formData : formik.values[fieldName]}
      // value={formdata !== '' ? formdata : formik.values[fieldName]}
      className="text-center"
      inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
      placeholder="$0.00"
      onChange={(e) => {
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.value)
      }}
      mode="currency"
      currency="USD"
      locale="en-US"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{
        width: "100%",
        height: "40px",
        boxSizing: "border-box",
        border: "none",
        fontSize: "16px",
        textAlign: "center !important",
        marginTop: "0px",
        outline: 'none',
      }}
    />
  );

  const renderPercentageInputArea = (fieldName, formData = '') => (
    <InputNumber

      value={formData != '' ? formData : formik.values[fieldName]}
      className="text-center"
      inputClassName={Number(formik.values[fieldName]) < 0 ? "is-negative" : "is-positive"}
      placeholder="0.00"
      maxFractionDigits={2}
      onChange={(e) => {
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.value)
      }}
      suffix="%"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{
        width: "100%",
        height: "40px",
        boxSizing: "border-box",
        border: "none",
        fontSize: "16px",
        textAlign: "center !important",
        marginTop: "0px",
      }}
    />
  );

  const renderSelect = (fieldName, formdata = '') => {
    var val = (formdata != '') ? formdata : formik.values[fieldName];
    console.log('val', val);



    return <select
      name={fieldName}
      id={fieldName}
      value={formdata !== '' ? formdata : formik.values[fieldName]}
      className={'select-text-color-' + val}
      onChange={(e) => {
        setExistPageWithoutSave(true);
        formik.setFieldValue(fieldName, e.target.value);
      }}
      style={{ width: '100%', textAlign: 'center', fontSize: '16px', color: 'white', backgroundColor: '#ff0000', border: 'none' }}
    >
      <option value="N">No</option>
      <option value="Y">Yes</option>
      <option value="NA">N/A</option>
    </select>

  };


  const renderSelect1 = (fieldName, formdata = '') => {


    return (
      <select
        name={fieldName}
        id={fieldName}
        value={formdata !== '' ? formdata : formik.values[fieldName]}
        className={'select-text-color-' + formik.values[fieldName]}
        onChange={(e) => {
          setExistPageWithoutSave(true);
          formik.setFieldValue(fieldName, e.target.value);
        }}
        style={{ width: '100%', textAlign: 'center', fontSize: '16px', color: 'white', backgroundColor: '#ff0000', border: 'none' }}
      >
        <option value="N">No</option>
        <option value="Y">Yes</option>
        {/* <option value="NA">NA</option> */}
      </select>
    );
  };





  //! -----------------------------------------------

  //? ------------------------------------------------
  const section_1_body = (title, fieldName_1, fieldName_2, fieldName_3, fieldName_4, fieldName_5) => {
    // renderInputArea
    return (
      <tr>
        <td style={{ ...cellStyle, minWidth: "250px" }}>{title}</td>

        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderInputAreaForAmount(fieldName_1, '', 'number')}</td>
        <td style={{ ...cellStyleW, minWidth: "250px" }}>{renderTextAreaFull(fieldName_2, '',)}</td>
        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderPercentageInputArea(fieldName_3, '', 'number')}</td>

        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderTextAreaFull(fieldName_4, '',)}</td>
        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderTextAreaFull(fieldName_5, '',)}</td>
      </tr>
    );
  }

  const section_2_body = (title, fieldName_1, fieldName_2, fieldName_3, fieldName_4, fieldName_5) => {
    // renderInputArea
    return (
      <tr>
        <td style={{ ...cellStyle, minWidth: "300px" }}>{title}</td>

        <td style={{ ...dropdownCellStyle, width: '100px', height: '32px', }}>
          {renderSelect1(fieldName_1)}
        </td>
        <td style={{ ...cellStyleW, minWidth: "350px" }}>{renderTextAreaFull(fieldName_2, '',)}</td>
        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderInputArea(fieldName_3, '', 'number')}</td>

        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderTextAreaFull(fieldName_4, '', '')}</td>
        <td style={{ ...cellStyleW, minWidth: "150px" }}>{renderTextAreaFull(fieldName_5, '', '')}</td>
      </tr>
    );
  }


  //? ------------------------------------------------

  const copyImageToClipboard = (blob) => {
    // Check if Clipboard API is available
    if (navigator.clipboard && navigator.clipboard.write) {
      navigator.clipboard.write([
        new ClipboardItem({
          [blob.type]: blob
        })
      ]).then(() => {
        setIsCopyBtnLoading(false);
        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Image copied to clipboard' });
        console.log('Image copied to clipboard');
      }).catch((error) => {
        setIsCopyBtnLoading(false);
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error copying image to clipboard' });
        console.error('Error copying image to clipboard:', error);
      });
    } else {
      setIsCopyBtnLoading(false);
      console.error('Clipboard API not available');
    }
  };
  const elementRefs = [
    useRef(null),
  ];
  
  const takeScreenshotAndCopy = async () => {
    setIsCopyBtnLoading(true);
    console.log('Take screenshot and copy to clipboard');
    console.log('Take screenshot and copy to clipboard', ref.current);

    try {
      const canvasPromises = elementRefs.map(async (ref) => {
        if (ref.current) {
          return await html2canvas(ref.current);
        }
        return null;
      });

      const canvases = await Promise.all(canvasPromises);

      // Calculate total height of combined screenshots
      const totalHeight = canvases.reduce((acc, canvas) => acc + canvas.height, 0);

      // Create a new canvas to combine screenshots
      const combinedCanvas = document.createElement('canvas');
      combinedCanvas.width = Math.max(...canvases.map(canvas => canvas.width));
      combinedCanvas.height = totalHeight;

      // Draw screenshots onto the combined canvas
      const context = combinedCanvas.getContext('2d');
      let offsetY = 0;
      canvases.forEach(canvas => {
        context.drawImage(canvas, 0, offsetY);
        offsetY += canvas.height;
      });

      // Convert the combined canvas to a data URL
      const imageDataURL = combinedCanvas.toBlob(blob => {
        if (blob) {
          // Copy blob to clipboard
          copyImageToClipboard(blob);
        } else {
          console.error('Error creating blob');
        }
      }, 'image/png');
      // const imageDataURL = combinedCanvas.toDataURL();

      // Do something with the data URL (e.g., display it, save it, etc.)
      console.log('Combined screenshot data URL:', imageDataURL);
    } catch (error) {
      setIsCopyBtnLoading(false);
      console.error('Error taking screenshots:', error);
    }

  };
  //* -------------------------


  return (
    <>
      <Toast ref={toast} />
      {isLoading ? (
        <div className="loading-spinner">
          Loading...
          <div className="spinner"></div>
        </div>
      ) : (
      <form onSubmit={formik.handleSubmit} className="interior-template-form">
     



        <div className="cardd" style={{ border: 'none', }} >
          <Accordion multiple activeIndex={[0, 1, 2, 3]}>

            <AccordionTab header="ACTION STEPS">
              <div className="table-container" style={{ overflowX: "auto" }}>
                <table style={{ borderCollapse: "collapse", }}>
                  <thead>
                    <tr>
                      <th style={{ ...headerStyle, width: "300px" }} >
                        ACTION STEPS
                      </th>
                      <th style={{ ...headerStyle, minWidth: "250px" }} colSpan={3} >
                        Address:
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto", }} rowSpan={2}  >
                        INTERIOR DESIGNER COMMENTS
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} rowSpan={2} >
                        VP CONSTRUCTION OPS COMMENTS ONLY
                      </th>
                    </tr>
                    <tr>
                      <th style={{ ...headerStyle, }} >
                      </th>
                      <th style={{ ...headerStyle, }} >
                        TOTAL
                      </th>
                      <th style={{ ...headerStyle, }} >
                        COMMENTS
                      </th>
                      <th style={{ ...headerStyle, }} >
                        % COMPLETE
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {section_1_body('ID Contract Amount:', 'IDContractAmountTotal', 'IDContractAmountComments', 'IDContractAmountPerComplete', 'IDContractAmountInterior', 'IDContractAmountVPC')}
                    {section_1_body('Amount Used:', 'AmountUsedTotal', 'AmountUsedComments', 'AmountUsedPerComplete', 'AmountUsedinterior', 'AmountUsedVPC')}
                    {section_1_body('GP%:', 'GpPerTotal', 'GpPerComments', 'GpPerComplete', 'GpPerInterior', 'GpPerVPC')}
                  </tbody>
                </table>
              </div>

            </AccordionTab>

            <AccordionTab header="DELIVERABLES" className="mt-2">

              <div className="table-container" style={{ overflowX: "auto" }}>
                <table style={{ borderCollapse: "collapse", }}>
                  <thead>

                    <tr>
                      <th style={{ ...headerStyle, width: "300px", }} >
                        DELIVERABLES
                      </th>

                      <th style={{ ...headerStyle, width: "100px", }} >
                        COMPLETE YES/NO
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        COMMENTS
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        INTERIOR DESIGNER COMMENTS
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        VP CONSTRUCTION OPS COMMENTS
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {section_2_body('Project Preference Sheet Complete', 'ProjectPreferenceComplete', 'ProjectPreferenceComments', 'ProjectPreferencePerComplete', 'ProjectPreferenceInterior', 'ProjectPreferenceVPC')}

                    {section_2_body('RFI\'s up to Date?', 'RFIComplete', 'RFIComments', 'RFIPerComplete', 'RFIInterior', 'RFIVPC')}

                    {section_2_body('Drawings up to date?', 'DrawingsComplete', 'DrawingsComments', 'DrawingsPerComplete', 'Drawingsinterior', 'DrawingsVPC')}

                    {section_2_body('Selection Choices up to date?', 'SelectionsComplete', 'SelectionsComments', 'SelectionsPerComplete', 'SelectionsInterior', 'SelectionsVPC')}

                    {section_2_body('Floor Plans (Concept) - Reno Only', 'FLoorPlanComplete', 'FLoorPlanComments', 'FLoorPlanPerComplete', 'FLoorPlanInterior', 'FLoorPlanVPC')}

                  </tbody>
                </table>
              </div>

            </AccordionTab>

            <AccordionTab header=" WEEKLY INTERIOR DESIGN UPDATE" className="mt-2">

              <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[0]}>

                <table style={{ borderCollapse: "collapse" }}>

                  <thead>

                    <tr>
                      <th style={{ ...headerStyle, minWidth: "auto", }} >
                        WEEKLY INTERIOR DESIGN UPDATE
                      </th>

                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        VP CONSTRUCTION OPS COMMENTS
                      </th>
                    </tr>

                  </thead>

                  <tbody>
                    <tr>

                      <td style={{ ...cellStyle, minWidth: "", }} >
                        Dear  {renderTextArea('dear', '???? ???',)}
                      </td>
                      <td style={{ ...cellStyle, minWidth: "530px", }} rowSpan={2}>
                        {renderTextAreaFull('dearVPCComments', '', '', 6)}
                      </td>

                    </tr>
                    <tr>
                      <td style={{}} >
                        <td style={{ ...cellStyle, minWidth: "300px", }} >
                          Here is your weekly summary from:
                        </td>
                        <td style={{ ...cellStyle, minWidth: "150px", }} >
                          <input
                            type="date"
                            name="summaryFrom"
                            id="summaryFrom"
                            value={formik.values['summaryFrom']}
                            onChange={(e) => formik.setFieldValue('summaryFrom', e.target.value)}
                            style={{ width: '100%', textAlign: 'center', fontSize: '16px', height: '32px', color: '#495057', }}

                          />
                        </td>
                        <td style={{ ...cellStyle, minWidth: "100px", textAlign: 'center', fontSize: 20 }} >
                          To
                        </td>
                        <td style={{ ...cellStyle, minWidth: "150px", }} >
                          <input
                            type="date"
                            name="summaryTo"
                            id="summaryTo"
                            value={formik.values['summaryTo']}
                            onChange={(e) => formik.setFieldValue('summaryTo', e.target.value)}
                            style={{ width: '100%', textAlign: 'center', fontSize: '16px', height: '32px', color: '#495057', }}
                          />
                        </td>

                      </td>
                    </tr>
                  </tbody>
                </table>


                <table style={{ borderCollapse: "collapse", marginTop: '20px' }}>
                  <thead>
                    <tr>
                      <th style={{ ...headerStyle, width: "300px", }} >
                        ID DOCUMENTS
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        Area
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        SELECTIONS
                      </th>
                      <th style={{ ...headerStyle, width: "100px" }} >
                        COMPLETED YES/NO/NA
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        INTERIOR DESIGNER COMMENTS
                      </th>
                      <th style={{ ...headerStyle, width: "100px" }} >
                        ID BID REQ
                      </th>
                      <th style={{ ...headerStyle, width: "100px" }} >
                        PO
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        PO or DRAWING DUE DATE
                      </th>
                      <th style={{ ...headerStyle, minWidth: "auto" }} >
                        VP CONSTRUCTION OPS COMMENTS
                      </th>


                    </tr>
                  </thead>

                  <tbody>

                    {InteriorDesignTemplate.getFormName().section_4.map((item, index) => {
                      return (
                        index == 0 ? (<tr>
                          <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={10}> Pre Start</td>
                          <td style={{ ...cellStyle }} rowSpan={10} >  </td>
                          <td style={{ ...cellStyle }} > {item.selection} </td>
                          <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_4.${index}.completed`, formik.values.section_4[index].completed)} </td>
                          <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_4.${index}.interiorDesignerComments`, ' ', formik.values.section_4[index].interiorDesignerComments)} </td>
                          <td style={{ ...dropdownCellStyle, minWidth: '100px', height: '32px', }}>  {renderSelect(`section_4.${index}.idBidReq`, formik.values.section_4[index].idBidReq)} </td>
                          <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_4.${index}.pO`, formik.values.section_4[index].pO)} </td>
                          <td style={{ ...cellStyleW, }}> {renderInputArea(`section_4.${index}.poOrDDue`, '', 'date', formik.values.section_4[index].poOrDDue)} </td>
                          <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_4.${index}.vPSComments`, ' ', formik.values.section_4[index].vPSComments)} </td>
                        </tr>) : (
                          <tr>

                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_4.${index}.completed`, formik.values.section_4[index].completed)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_4.${index}.interiorDesignerComments`, '', formik.values.section_4[index].interiorDesignerComments)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_4.${index}.idBidReq`, formik.values.section_4[index].idBidReq)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_4.${index}.pO`, formik.values.section_4[index].pO)} </td>
                            <td style={{ ...cellStyleW, }}> {renderInputArea(`section_4.${index}.poOrDDue`, '', 'date', formik.values.section_4[index].poOrDDue)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_4.${index}.vPSComments`, '', formik.values.section_4[index].vPSComments)} </td>
                          </tr>
                        )
                      )
                    })

                    }
                    {/* SCHEDULES  EXTERIOR  Start */}
                    {InteriorDesignTemplate.getFormName().section_5.map((item, index) => {
                      return (
                        index == 0 ? (<tr>
                          <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={14}> SCHEDULES</td>
                          <td style={{ ...cellStyle }} rowSpan={4} > EXTERIOR  </td>
                          <td style={{ ...cellStyle }} > {item.selection} </td>
                          <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_5.${index}.completed`, formik.values.section_5[index].completed)} </td>
                          <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_5.${index}.interiorDesignerComments`, '', formik.values.section_5[index].interiorDesignerComments)} </td>
                          <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_5.${index}.idBidReq`, formik.values.section_5[index].idBidReq)} </td>
                          <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_5.${index}.pO`, formik.values.section_5[index].pO)} </td>
                          <td style={{ ...cellStyleW, }}> {renderInputArea(`section_5.${index}.poOrDDue`, '', 'date', formik.values.section_5[index].poOrDDue)} </td>
                          <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_5.${index}.vPSComments`, '', formik.values.section_5[index].vPSComments)} </td>

                        </tr>) : (
                          <tr>

                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_5.${index}.completed`, formik.values.section_5[index].completed)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_5.${index}.interiorDesignerComments`, '', formik.values.section_5[index].interiorDesignerComments)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_5.${index}.idBidReq`, formik.values.section_5[index].idBidReq)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_5.${index}.pO`, formik.values.section_5[index].pO)} </td>
                            <td style={{ ...cellStyleW, }}> {renderInputArea(`section_5.${index}.poOrDDue`, '', 'date', formik.values.section_5[index].poOrDDue)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_5.${index}.vPSComments`, '', formik.values.section_5[index].vPSComments)} </td>

                          </tr>
                        )
                      )
                    })

                    }

                    {/* SCHEDULES  EXTERIOR  End */}
                    {/* SCHEDULES  INTERIOR  start */}
                    {InteriorDesignTemplate.getFormName().section_6.map((item, index) => {
                      return (
                        index == 0 ? (<tr>

                          <td style={{ ...cellStyle }} rowSpan={11} > INTERIOR  </td>
                          <td style={{ ...cellStyle }} > {item.selection} </td>
                          <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_6.${index}.completed`, formik.values.section_6[index].completed)} </td>
                          <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_6.${index}.interiorDesignerComments`, '', formik.values.section_6[index].interiorDesignerComments)} </td>
                          <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_6.${index}.idBidReq`, formik.values.section_6[index].idBidReq)} </td>
                          <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_6.${index}.pO`, formik.values.section_6[index].pO)} </td>
                          <td style={{ ...cellStyleW, }}> {renderInputArea(`section_6.${index}.poOrDDue`, '', 'date', formik.values.section_6[index].poOrDDue)} </td>
                          <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_6.${index}.vPSComments`, '', formik.values.section_6[index].vPSComments)} </td>
                        </tr>) : (
                          <tr>

                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_6.${index}.completed`, formik.values.section_6[index].completed)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_6.${index}.interiorDesignerComments`, '', formik.values.section_6[index].interiorDesignerComments)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_6.${index}.idBidReq`, formik.values.section_6[index].idBidReq)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_6.${index}.pO`, formik.values.section_6[index].pO)} </td>
                            <td style={{ ...cellStyleW, }}> {renderInputArea(`section_6.${index}.poOrDDue`, '', 'date', formik.values.section_6[index].poOrDDue)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_6.${index}.vPSComments`, ' ', formik.values.section_6[index].vPSComments)} </td>
                          </tr>
                        )
                      )
                    })

                    }
                    {/* SCHEDULES  INTERIOR  End */}


                    {/* DRAWINGS  EXTERIOR  Start */}
                    {/* DRAWINGS  EXTERIOR  End - Section removed (not applicable) */}

                    {/* DRAWINGS  INTERIOR  start */}
                    {InteriorDesignTemplate.getFormName().section_8.map((item, index) => {
                      return (
                        index == 0 ? (<tr>
                          <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={12}> DRAWINGS</td>
                          <td style={{ ...cellStyle }} rowSpan={12} > INTERIOR  </td>
                          <td style={{ ...cellStyle }} > {item.selection} </td>
                          <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_8.${index}.completed`, formik.values.section_8[index].completed)} </td>
                          <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_8.${index}.interiorDesignerComments`, ' ', formik.values.section_8[index].interiorDesignerComments)} </td>
                          <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_8.${index}.idBidReq`, formik.values.section_8[index].idBidReq)} </td>
                          <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_8.${index}.pO`, formik.values.section_8[index].pO)} </td>
                          <td style={{ ...cellStyleW, }}> {renderInputArea(`section_8.${index}.poOrDDue`, '', 'date', formik.values.section_8[index].poOrDDue)} </td>
                          <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_8.${index}.vPSComments`, ' ', formik.values.section_8[index].vPSComments)} </td>
                        </tr>) : (
                          <tr>

                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_8.${index}.completed`, formik.values.section_8[index].completed)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_8.${index}.interiorDesignerComments`, ' ', formik.values.section_8[index].interiorDesignerComments)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_8.${index}.idBidReq`, formik.values.section_8[index].idBidReq)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_8.${index}.pO`, formik.values.section_8[index].pO)} </td>
                            <td style={{ ...cellStyleW, }}> {renderInputArea(`section_8.${index}.poOrDDue`, '', 'date', formik.values.section_8[index].poOrDDue)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_8.${index}.vPSComments`, ' ', formik.values.section_8[index].vPSComments)} </td>
                          </tr>
                        )
                      )
                    })

                    }
                    {/* DRAWINGS  INTERIOR  End */}


                    {InteriorDesignTemplate.getFormName().section_9.map((item, index) => {
                      return (
                        index == 0 ? (<tr>
                          <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={6}> Site Inspections Complete</td>
                          <td style={{ ...cellStyle }} rowSpan={6} >  </td>
                          <td style={{ ...cellStyle }} > {item.selection} </td>
                          <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_9.${index}.completed`, formik.values.section_9[index].completed)} </td>
                          <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_9.${index}.interiorDesignerComments`, ' ', formik.values.section_9[index].interiorDesignerComments)} </td>
                          <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_9.${index}.idBidReq`, formik.values.section_9[index].idBidReq)} </td>
                          <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_9.${index}.pO`, formik.values.section_9[index].pO)} </td>
                          <td style={{ ...cellStyleW, }}> {renderInputArea(`section_9.${index}.poOrDDue`, '', 'date', formik.values.section_9[index].poOrDDue)} </td>
                          <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_9.${index}.vPSComments`, ' ', formik.values.section_9[index].vPSComments)} </td>
                        </tr>) : (
                          <tr>

                            <td style={{ ...cellStyle }} > {item.selection} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_9.${index}.completed`, formik.values.section_9[index].completed)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_9.${index}.interiorDesignerComments`, ' ', formik.values.section_9[index].interiorDesignerComments)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelect(`section_9.${index}.idBidReq`, formik.values.section_9[index].idBidReq)} </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelect(`section_9.${index}.pO`, formik.values.section_9[index].pO)} </td>
                            <td style={{ ...cellStyleW, }}> {renderInputArea(`section_9.${index}.poOrDDue`, '', 'date', formik.values.section_9[index].poOrDDue)} </td>
                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFull(`section_9.${index}.vPSComments`, ' ', formik.values.section_9[index].vPSComments)} </td>
                          </tr>
                        )
                      )
                    })

                    }
                    <tr>
                      <td>Risk/Safety/Client/Team/Other?</td>
                      <td style={{ ...cellStyleW, }} colSpan={8}>  {renderTextAreaFull('riskSafety', '')} </td>
                    </tr>




                  </tbody>
                </table>


              </div>

            </AccordionTab>

            <AccordionTab header="GENERAL PROJECT CHECK LIST" className="mt-2">
              <div className="table-container" style={{ overflowX: "auto" }}>
                <table style={{ borderCollapse: "collapse" }}>
                  <thead style={{ overflowX: "auto" }}>
                    <tr>
                      <th style={{ ...headerStyle, }} >
                        General projects checklist:
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {preConstructionShedule.map((item, index) => {
                      return (
                        <tr>
                          <td >
                            <td style={{ ...cellStyleW, width: "300px", }}>
                              {renderInputArea('section_10.' + index + '.genrealProjectCheckListTitle', '', '', formik.values.section_10[index].genrealProjectCheckListTitle)}
                            </td>
                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>
                              {renderSelect('section_10.' + index + '.misc1', formik.values.section_10[index].misc1)}
                            </td>
                            <td style={{ ...cellStyleW, width: '70vw' }}>
                              {renderTextAreaFull('section_10.' + index + '.miscReason', '', formik.values.section_10[index].miscReason)}
                            </td>
                            <td style={{ ...cellStyleW, minWidth: "100px" }}>
                              {index > 0 ? (<FaTrash className='delete-buttonXX' onClick={() => handleDeleteInputForreConstructionShedule(index)} />) : null}

                              {preConstructionShedule.length - 1 == index ? (<FaPlus className='add-buttonXX' onClick={() => handleAddInputForPreConstructionShedule()} />) : null}
                            </td>

                          </td>
                        </tr>

                      )
                    })}
                  </tbody>
                </table>
              </div>
            </AccordionTab>

          </Accordion>
        </div>
      </form>
      )}
    </>
  );
};

export default EDIT_INTERIOR_DESIGN_TEMPLATE